import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CustomLink from '../Component/CustomLink/CustomLink';
import './Header.css';
const Header = () => {

  const[search, setSearch] = useState('')
  const searchValue = (e) => {
    setSearch(e.target.value);
  };
    return (
      <div>
        <div className="navbar p-4 bg-indigo-700 text-white">
          <div className="navbar-start">
            <div className="list-none gap-8 pl-6 hidden md:flex">
              <li className="text-white text-lg hover:text-pink-400">
                <CustomLink to="/">Home</CustomLink>
              </li>
              <li className="text-white text-lg hover:text-pink-400">
                <CustomLink to="/playlist">Playlist</CustomLink>
              </li>
              <li className="text-white text-lg hover:text-pink-400">
                <CustomLink to="/videos">All Videos</CustomLink>
              </li>
              <li className="text-white text-lg hover:text-pink-400">
                <CustomLink to="/about">About</CustomLink>
              </li>
              <li className="text-white text-lg hover:text-pink-400">
                <CustomLink to="/WriteBlog">Blogs</CustomLink>
              </li>
            </div>
            <div className="dropdown md:hidden">
              <label tabIndex={0} className="btn btn-ghost btn-circle">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h7"
                  />
                </svg>
              </label>
              <ul
                tabIndex={0}
                className="menu menu-compact dropdown-content  mt-3 p-2 shadow bg-indigo-600 rounded-box w-52"
              >
                <li className="text-white text-lg hover:text-pink-400">
                  <CustomLink to="/">Home</CustomLink>
                </li>
                <li className="text-white text-lg hover:text-pink-400">
                  <CustomLink to="/playlist">Playlist</CustomLink>
                </li>
                <li className="text-white text-lg hover:text-pink-400">
                  <CustomLink to="/videos">All Videos</CustomLink>
                </li>
                <li className="text-white text-lg hover:text-pink-400">
                  <CustomLink to="/about">About</CustomLink>
                </li>
                <li className="text-white text-lg hover:text-pink-400">
                  <CustomLink to="/WriteBlog">Blogs</CustomLink>
                </li>
              </ul>
            </div>
          </div>
          <div className="navbar-center">
            <a
              href="https://youtube.com/c/OnlineITGhor"
              target="blank"
              className="btn btn-ghost normal-case text-2xl"
            >
              Online It Ghor
            </a>
          </div>
          <div className="navbar-end">
            <button className="btn btn-ghost btn-circle md:hidden">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </button>

            {/* ------------Search field------------- */}

            <div className=" xl:w-70 md:w-56 hidden md:block items-center mr-5">
            </div>
            <div className="form-control hidden md:block">
              <div className="input-group ">
                <input
                  onChange={searchValue}
                  type="text"
                  placeholder="Search Videos…"
                  className="input  text-black"
                />
                <Link to={`/searchVideo/${search}`}>
                  <button className="btn btn-square">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </button>
                </Link>
                
              </div>
            </div>

            {/* ------------------------------ */}

            <div className="dropdown dropdown-end dropdown-hover">
              <label tabIndex={0} className="btn btn-ghost btn-circle avatar">
                <button className="btn btn-ghost btn-circle">
                  <div className="indicator">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                      />
                    </svg>
                    <span className="badge badge-xs badge-secondary indicator-item"></span>
                  </div>
                </button>
              </label>
              <ul
                tabIndex={0}
                className="menu menu-compact dropdown-content  min-h-[500%] mt-3 p-2 shadow bg-white rounded-box w-52"
              >
                <div className=" m-auto text-xl text-black">
                  <p>no notifications.</p>
                </div>
                {/* <li className='text-black'><a></a></li>
                <li className='text-black'><a>Settings</a></li>
                    <li className='text-black'><a>Logout</a></li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
};

export default Header;